import React, { useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { useClusterRCFAnalysisStore } from 'store/clusterRCFAnalysis.store';

import { Radio } from 'components/DesignSystem/Radio';
import classes from 'components/pages/DurationForecastPage/components/DurationForecastFilter/components/ToggleClusteringOption/ToggleClusteringOption.module.scss';

export const ToggleClusteringOption = () => {
    const history = useHistory();
    const { update } = useClusterRCFAnalysisStore();
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);
    const clusteringOption = urlSearchParams.get('option') || 'automated';

    useEffect(() => {
        if (clusteringOption) {
            update({ isAutomatedClusteringOption: clusteringOption === 'automated' });
        }
    }, []);

    const selectClusteringOption = (event) => {
        const selection = event.target.value;
        if (urlSearchParams.has('option')) {
            urlSearchParams.set('option', selection);
        } else {
            urlSearchParams.append('option', selection);
        }

        history.push({
            search: `?${urlSearchParams.toString()}`,
        });

        update({ isAutomatedClusteringOption: selection === 'automated' });
    };

    const controlProps = (item) => ({
        checked: clusteringOption === item,
        onChange: selectClusteringOption,
        value: item,
        name: 'clustering-option',
    });

    return (
        <div className={classes.toggleClusteringOptionContainer}>
            <span>Clustering:</span>

            <Radio {...controlProps('automated')} label={'Automated'} />

            <Radio {...controlProps('custom')} label={'Custom'} />
        </div>
    );
};
